module.exports = __webpack_public_path__ + "img/icon_user_title.c8601a05.png";